import { render, staticRenderFns } from "./ConfigAction.vue?vue&type=template&id=2ff9de18&scoped=true"
import script from "./ConfigAction.vue?vue&type=script&lang=js"
export * from "./ConfigAction.vue?vue&type=script&lang=js"
import style0 from "./ConfigAction.vue?vue&type=style&index=0&id=2ff9de18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff9de18",
  null
  
)

export default component.exports